import React from 'react'
import { Skeleton } from '@surecompanies/core_components'

import styles from './Skeletons.module.scss'

/**
 * Subtle indeterminate progress bar for background refetches. The 3px track
 * is always reserved (transparent when idle) so toggling `$active` never
 * shifts layout — render it at the top of a table/list container.
 */
export const UpdatingBar: React.FC<{ $active: boolean }> = ({ $active }) => (
  <div
    className={`${styles.updatingBar}${$active ? ` ${styles.active}` : ''}`}
  />
)

interface TableSkeletonProps {
  rowCount?: number
}

export const TableSkeleton: React.FC<TableSkeletonProps> = ({
  rowCount = 8,
}) => (
  <div className={styles.box}>
    {Array.from({ length: rowCount }).map((_, i) => (
      <div className={styles.row} key={i}>
        <Skeleton.Input active size="small" style={{ width: 180 }} />
        <Skeleton.Input active size="small" style={{ width: 140 }} />
        <Skeleton.Input active size="small" style={{ width: '60%' }} />
        <Skeleton.Input active size="small" style={{ width: 80 }} />
        <Skeleton.Input active size="small" style={{ width: 80 }} />
        <Skeleton.Button active size="small" style={{ width: 90 }} />
      </div>
    ))}
  </div>
)
